import type { DocumentReference, Reference } from '@medplum/fhirtypes'
import { ExtendedDocumentReference } from '@seen/core/models/document-references/documentReferences'
import { IconFile } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useRead } from '#src/hooks/useRead.ts'

export function DocumentReferenceOption({
  documentReference,
}: {
  documentReference: Reference<DocumentReference>
}): JSX.Element {
  const { data: instance } = useRead(
    ExtendedDocumentReference,
    documentReference
  )
  return (
    <div className="flex items-center gap-2">
      <div className="p-0.5">
        <IconFile className="size-4 shrink-0" />
      </div>
      <span>{instance?.title}</span>
    </div>
  )
}
